const ALLOWED_EXTERNAL_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:']

const isSafeLink = (url?: string) => {
  const parsedUrl = url?.trim()

  if (!parsedUrl) {
    return false
  }

  if (parsedUrl.startsWith('/')) {
    return true
  }

  try {
    const normalizedUrl = new URL(parsedUrl)

    return ALLOWED_EXTERNAL_PROTOCOLS.includes(normalizedUrl.protocol)
  } catch {
    return false
  }
}

export default isSafeLink
